import { useState } from 'react';

const RED = '#E11D48';
const BLUE = '#1B4F8C';

export default function RegistrationBanner({ stateCode }: { stateCode: string }): JSX.Element {
  const [expanded, setExpanded] = useState(false);

  return (
    <div
      style={{
        background: '#FFF1F2',
        border: `1.5px solid ${RED}`,
        borderRadius: 10,
        padding: '14px 16px',
        marginBottom: 12,
      }}
    >
      <div style={{ fontWeight: 700, color: RED, fontSize: 13, marginBottom: 6 }}>
        Registration Required — Act Now
      </div>
      <div style={{ fontSize: 12, color: '#9F1239', lineHeight: 1.55, marginBottom: 10 }}>
        Your direct sales exceeded the {stateCode} economic nexus threshold. You must register for a
        sales tax permit immediately.
      </div>
      <div style={{ fontSize: 11, color: '#9F1239', lineHeight: 1.5, marginBottom: 12 }}>
        Failure to register exposes you to back taxes, interest, and penalties in {stateCode}.
      </div>
      {expanded ? (
        <div
          style={{
            background: '#fff',
            border: '1px solid #FECDD3',
            borderRadius: 7,
            padding: '12px 14px',
          }}
        >
          <div style={{ fontSize: 12, fontWeight: 700, color: '#0F172A', marginBottom: 4 }}>
            Automated registration is coming soon
          </div>
          <div style={{ fontSize: 12, color: '#475569', lineHeight: 1.55, marginBottom: 10 }}>
            The Registration Manager will automate SSTRS enrollment in a future release. Until then,
            register manually through the Streamlined Sales Tax portal.
          </div>
          <a
            href="https://www.streamlinedsalestax.org"
            target="_blank"
            rel="noopener noreferrer"
            style={{ fontSize: 12, fontWeight: 700, color: BLUE, textDecoration: 'none' }}
          >
            Register at streamlinedsalestax.org →
          </a>
        </div>
      ) : (
        <button
          type="button"
          onClick={() => setExpanded(true)}
          style={{
            display: 'inline-flex',
            alignItems: 'center',
            gap: 6,
            background: RED,
            color: '#fff',
            border: 'none',
            borderRadius: 7,
            padding: '8px 18px',
            fontSize: 12,
            fontWeight: 700,
            cursor: 'pointer',
          }}
        >
          Register Now →
        </button>
      )}
    </div>
  );
}
